import { job_field, academic_field } from "../static/static_field";

/**
 * Helper function to get Chinese display name for field values
 * @param {string|number} value - The field value to convert
 * @param {string} fieldType - The type of field ('job_field' or 'academic_field')
 * @returns {string} The Chinese display name or original value if not found
 */
export const getFieldDisplayName = (value, fieldType) => {
    if (!value) return value;
    
    if (fieldType === 'job_field') {
        const field = job_field.find(item => item.value === parseInt(value));
        return field ? field.label : value;
    }
    
    if (fieldType === 'academic_field') {
        const field = academic_field.find(item => item.value === parseInt(value));
        return field ? field.label : value;
    }
    
    return value;
};

/**
 * Get job field display name by value
 * @param {string|number} value - The job field value
 * @returns {string} The Chinese display name or original value
 */
export const getJobFieldName = (value) => {
    return getFieldDisplayName(value, 'job_field');
};

/**
 * Get academic field display name by value  
 * @param {string|number} value - The academic field value
 * @returns {string} The Chinese display name or original value
 */
export const getAcademicFieldName = (value) => {
    return getFieldDisplayName(value, 'academic_field');
};